//
//
//
//
//
//
//
//
//
//
//

import eloading from '@/components/eloading/eloading'
import router from './router'
export default {
  name: 'App',
  data(){
    return {
      
    }
  },
  components:{eloading},
  computed:{
    isLoading(){
      return this.$store.state.Loading
    }
  }
}
